import React, { useEffect, useState, useCallback } from 'react'
import UIWindowModal from './UIWindowModal';
import useEmblaCarousel from 'embla-carousel-react';
import { mergeClasses } from '@griffel/react';

const UIWindowModalPages = ({ className, isOpen, onClose, pages, hasClose = true, thumbType = "dots", hasOverlays = false }) =>
{
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [activeIndex, setActiveIndex] = useState(0);

	const [emblaRef, emblaApi] = useEmblaCarousel(
	{
		loop: false,
		duration: 20
	}
	);

	const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel(
	{
		containScroll: 'keepSnaps',
		dragFree: true
	}
	);

	const onThumbClick = useCallback((index) =>
	{
		if (!emblaApi) return;
		emblaApi.scrollTo(index);
	},
	[emblaApi]
	);

	const onSelect = useCallback(() =>
	{
		if (!emblaApi) return;
		const index = emblaApi.selectedScrollSnap();
		setSelectedIndex(index);
		setActiveIndex(index);

		if (emblaThumbsApi)
		{
			emblaThumbsApi.scrollTo(index);
		}
	},
	[emblaApi, emblaThumbsApi]
	);

	useEffect(() =>
	{
		if (!emblaApi) return;
		onSelect();
		emblaApi.on('select', onSelect);
		emblaApi.on('reInit', onSelect);
	},
	[emblaApi, onSelect]
	);

	className = mergeClasses("window-pages", className);

	return (
		<UIWindowModal className={className} isOpen={isOpen} onClose={onClose} hasClose={hasClose}>
			{hasOverlays && (
				<div className="slide-overlays">
					{pages.map((item, index) => (
						<div 
							key={index}
							className={mergeClasses(
								"slide-overlay-item",
								activeIndex === index ? "active" : ""
							)}
							data-index={index}
						>
							{item.overlay || null}
						</div>
					))}
				</div>
			)}
			<div className="modal-container">
				<div className="modal-container-inner">
					<div className="embla__slides" ref={emblaRef}>
						<div className="embla__container">
							{pages.map((item, index) => (
								<div 
									className={mergeClasses("embla__slide", item.key)} 
									key={index} 
									data-index={index}
								>
									{emblaApi ? item.content(
										emblaApi.scrollNext,
										emblaApi.scrollPrev,
										index,
										pages.length
									) : null}
								</div>
							))}
						</div>
					</div>

					{thumbType === "dots" && (
						<Thumbs
							emblaThumbsApi={emblaThumbsApi}
							emblaThumbsRef={emblaThumbsRef}
							slides={pages}
							onThumbClick={onThumbClick}
							selectedIndex={selectedIndex}
							thumbType={thumbType}
						/>
					)}

					{thumbType === "number" && (
						<div className="embla-thumbs__slide__number">
							<span className="current">{selectedIndex + 1}</span>
							<span className="hyphen">/</span>
							<span className="total">{pages.length}</span>
						</div>
					)}
				</div>
			</div>
		</UIWindowModal>
	);
};

const Thumbs = ({ emblaThumbsRef, slides, onThumbClick, selectedIndex }) =>
{
	return (
		<div className="embla-thumbs">
			<div className="embla-thumbs__viewport" ref={emblaThumbsRef}>
				<div className="embla-thumbs__container">
					{slides.map((_, index) => (
						<Thumb
							key={index}
							onClick={() => onThumbClick(index)}
							selected={index === selectedIndex}
							totalSlides={slides.length}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

const Thumb = ({ onClick, selected }) =>
{
	return (
		<div className={'embla-thumbs__slide' + (selected ? ' selected' : '')}>
			<button onClick={onClick} type="button" className="embla-thumbs__slide__dot" />
		</div>
	);
};


export default UIWindowModalPages;
